import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = {
  key: 0,
  class: "preview-wrapper flex-1"
}
const _hoisted_3 = { class: "relative block h-full" }
const _hoisted_4 = { class: "preview-card" }
const _hoisted_5 = { class: "relative block min-h-full divide-y-1 divide-solid divide-secondary-300 px-4 pb-6" }

import EntryDetailsPanelClose from '@/components/entry/EntryDetailsPanelClose.vue'
import { useAttrs } from 'vue'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TableWithPreview',
  inheritAttrs: false
},
  __name: 'TableWithPreview',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit



const { class: classes, ...attrs } = useAttrs()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row", _unref(classes)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "table", _normalizeProps(_guardReactiveProps(attrs)))
    ]),
    (_ctx.$slots.preview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(EntryDetailsPanelClose, {
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "close")
                  ]),
                  _: 3
                }),
                _renderSlot(_ctx.$slots, "preview", _normalizeProps(_guardReactiveProps(attrs)))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})